import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { FilterItem, FilterType } from './FilterItem';
import styles from './filter_box.module.scss';
import { MaterialIcon } from '../../../../../components/material-icon/MaterialIcon';

const searchTypePlaceholder = (searchType: 'arret' | 'commentary' | 'law') => {
  return {
    arret: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/1" />
    ),
    commentary: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/2" />
    ),
    law: (
      <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/3" />
    ),
  }[searchType];
};

type Props = {
  searchType: 'arret' | 'commentary' | 'law';
  filters: Array<FilterType>;
};

export const FilterBoxChips: FC<Props> = ({ searchType, filters }) => {
  const FILTER_DISPLAY_MAX_NUMBER = 4;

  const [showFullList, setShowFullList] = useState(false);
  const canDisplayToggler = filters.length > FILTER_DISPLAY_MAX_NUMBER;

  const toggle = () => setShowFullList(previous => !previous);

  const filterListToDisplay = showFullList
    ? filters
    : filters.slice(0, FILTER_DISPLAY_MAX_NUMBER);

  return (
    <>
      <div className={styles.content}>
        {filterListToDisplay.length > 0 &&
          filterListToDisplay.map(filter => (
            <FilterItem
              key={filter.labelFull || filter.label || filter.title}
              filter={filter}
            />
          ))}

        {filterListToDisplay.length === 0 && (
          <span className={styles.emptyText}>
            {searchTypePlaceholder(searchType)}
          </span>
        )}
      </div>
      {canDisplayToggler && (
        <button className={styles.seeMore} onClick={toggle} type="button">
          {!showFullList && (
            <>
              <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/5" />{' '}
              <MaterialIcon name="keyboard_arrow_down" />
            </>
          )}
          {showFullList && (
            <>
              <FormattedMessage id="search/components/search-snippets/aside/filter-box/FilterBox.tsx/6" />{' '}
              <MaterialIcon name="keyboard_arrow_up" />
            </>
          )}
        </button>
      )}
    </>
  );
};
